import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SucursalInformacionComercialEdit } from "./edit";
import { SucursalInformacionComercial, FiltroSucursalInformacionComercial, SucursalInformacionComercialDTO, Mes } from "app/models/requireme";
const EditModal = SucursalInformacionComercialEdit;

type Entity = models.SucursalInformacionComercialDTO;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void> | void;
    readonly?: boolean;
}



/**
* Listado de SucursalInformacionComercial
*/
class SucursalInformacionComercialListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);
        if (result.result) {
            const oldList = this.props.value;
            const newItem = {...result.value, MesesConfigurados: result.value.InformacionComercialMes.length, ListadoMesesConfigurados: this.MesesConfigurados(result.value)} as Entity;
            await this.props.onChange([...oldList, newItem]);
        }
    }
/**Obtiene las columnas del grid */
 columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    
    return [
        botones,
        { title: "Año", cell: x => ({ data: x.Año }) },
        { title: "Meses", cell: x => ({ data: x.MesesConfigurados }) },
        { title: "", cell: x => ({ data: this.MesesConfigurados(x)}) },
    ];
}
    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const oldList = this.props.value;
            const newItem = {...result.value, MesesConfigurados: result.value.InformacionComercialMes.length, ListadoMesesConfigurados: this.MesesConfigurados(result.value)} as Entity;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar información comercial?", item.Año + "");
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    public MesesConfigurados(x: SucursalInformacionComercial): string
    {
        const meses = x.InformacionComercialMes.map(x=> this.ObtenerMesString(x.Mes));        
        const cadena = meses.join();
        return cadena;
    }

    public ObtenerMesString(x: Mes): string
    {
        let mes = "Enero";

        switch(x)
        {
            case Mes.Febrero:
                mes = "Febrero";
            break;
            case Mes.Marzo:
                mes = "Marzo";
            break;
            case Mes.Abril:
                mes = "Abril";
            break;
            case Mes.Mayo:
                mes = "Mayo";
            break;
            case Mes.Junio:
                mes = "Junio";
            break;
            case Mes.Julio:
                mes = "Julio";
            break;
            case Mes.Agosto:
                mes = "Agosto";
            break;
            case Mes.Septiembre:
                mes = "Septiembre";
            break;
            case Mes.Octubre:
                mes = "Octubre";
            break;
            case Mes.Noviembre:
                mes = "Noviembre";
            break;
            case Mes.Diciembre:
                mes = "Diciembre";
            break;
        }
        return mes;
    }

    render() {
        const cols = this.columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Información comercial por año</span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const SucursalInformacionComercialList = kea.mapProps(componentToRx(SucursalInformacionComercialListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/edit/informacioncomercial/list.tsx